var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.08C29.24 28.08 28.56 28.38 28.04 28.85L20.91 24.7C20.96 24.47 21 24.24 21 24C21 23.76 20.96 23.53 20.91 23.3L27.96 19.19C28.5 19.69 29.21 20 30 20C31.66 20 33 18.66 33 17C33 15.34 31.66 14 30 14C28.34 14 27 15.34 27 17C27 17.24 27.04 17.47 27.09 17.7L20.04 21.81C19.5 21.31 18.79 21 18 21C16.34 21 15 22.34 15 24C15 25.66 16.34 27 18 27C18.79 27 19.5 26.69 20.04 26.19L27.16 30.35C27.11 30.56 27.08 30.78 27.08 31C27.08 32.61 28.39 33.92 30 33.92C31.61 33.92 32.92 32.61 32.92 31C32.92 29.39 31.61 28.08 30 28.08Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareButton);
export default __webpack_public_path__ + "static/media/ShareButton.ccd23bb43804eee72e40581b843c68a9.svg";
export { ForwardRef as ReactComponent };